// src/context/furnitureContext.tsx
import { createContext, useContext, type ReactNode } from 'react'
import type { FurnitureDto } from '~/utils/furnitureBySku'

/**
 * Holds the backend furniture definition (fetched once per product in the
 * configurator) so deep children — e.g. the pricing-quote builder — can resolve
 * backend ids like chipboardId without re-fetching or prop drilling.
 */
const FurnitureContext = createContext<FurnitureDto | null>(null)

export function FurnitureProvider(props: {
  value: FurnitureDto | null
  children: ReactNode
}) {
  return (
    <FurnitureContext.Provider value={props.value}>
      {props.children}
    </FurnitureContext.Provider>
  )
}

export function useFurniture(): FurnitureDto | null {
  return useContext(FurnitureContext)
}